import { LocalStorageKeys } from "../LocalStorageKeys"
import { LocalStorageService } from "../services/local-storage/local-storage.service"

  /**
   * Get empty resource for error reporting
   *
   * @returns 
   */
  export const getEmptyResource = (localStorage: LocalStorageService) => {
    return {
      providerID: 'NA', 
      storefrontID: localStorage.getItem(LocalStorageKeys.STOREFRONTID) ?? 'NA', 
      contentKey: 'NA', 
      contentID: 'NA', 
      containerID: 'NA', 
      contentType: 'NA', 
      contentGenre: 'NA', 
      contentName: 'NA', 
      seriesName: 'NA', 
      seasonNumber: 'NA', 
      episodeNumber: 'NA',
      tabID: 'NA',
      tabName: 'NA', 
      // player
      playbackURL: 'NA', 
      drmName: 'NA', 
      drmVersion: 'NA', 
      contentDurationSec: 0, 
      videoResolution: 'NA', 
      currentBandwidthKb: 0, 
      highestVariantBandwidthKb: 0, 
      lowestVariantBandwidthKb: 0, 
      lastPlayedVariant: 0, 
      lastAttemptedVariant: 0, 
      audioLanguage: 'NA', 
      subtitleLanguage: 'NA', 
    }
  }
